// extracted by mini-css-extract-plugin
export default {"default":"styles_default__s30DK","wrapper":"styles_wrapper__6NpOy"};